import { useState } from 'react';
import { categories, stats } from '@/mocks/categories';

export default function StatsCategories() {
  const [activeTab, setActiveTab] = useState('all');

  const featuredCategories = categories.slice(0, 6);

  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
            <div className="bg-foreground-950 rounded-2xl p-6 md:p-8 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-2 mb-6">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800">
                    <i className="ri-bar-chart-2-line text-background-50 text-lg"></i>
                  </div>
                  <span className="text-xs font-medium text-background-50/60 uppercase tracking-wider">Statistics</span>
                </div>
                <div className="space-y-5">
                  {stats.map((stat) => (
                    <div key={stat.label}>
                      <div className="flex items-center gap-3 mb-1">
                        <i className={`${stat.icon} text-primary-400 text-lg`}></i>
                        <span className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</span>
                      </div>
                      <p className="text-sm text-background-50/50 ml-8">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-xs text-background-50/40 mt-6 leading-relaxed">
                Thousands of users rely on AcBuy Spreadsheet every month to discover trusted products and verified sellers.
              </p>
            </div>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8 relative overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20flat%20lay%20product%20photography%20with%20soft%20cream%20background%2C%20fashion%20accessories%20and%20clothing%20items%20arranged%20neatly%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20soft%20natural%20lighting%2C%20elegant%20harmonious%20composition%2C%20subtle%20texture&width=900&height=700&seq=stats-cat-bg-v3&orientation=portrait"
                alt="Product categories"
                className="absolute inset-0 w-full h-full object-cover object-top rounded-2xl opacity-35"
              />
              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm mb-4">
                  <i className="ri-grid-line text-sm text-foreground-700"></i>
                  <span className="text-xs font-medium text-foreground-700">Categories</span>
                </div>

                <div className="flex flex-wrap gap-2 mb-5">
                  {['all', ...featuredCategories.map(c => c.name)].slice(0, 7).map((tab) => (
                    <button
                      key={tab}
                      onClick={() => setActiveTab(tab === 'all' ? 'all' : tab)}
                      className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                        activeTab === tab || (tab === 'all' && activeTab === 'all')
                          ? 'bg-foreground-950 text-background-50'
                          : 'bg-background-50/80 text-foreground-600 hover:bg-background-50'
                      }`}
                    >
                      {tab === 'all' ? 'All' : tab}
                    </button>
                  ))}
                </div>

                <div className="space-y-2 mb-5 max-h-[400px] overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 p-3 rounded-xl bg-background-50/80 hover:bg-background-50 transition-colors group cursor-pointer"
                    >
                      <div className="w-10 h-10 flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={cat.imageUrl}
                          alt={cat.name}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <span className="text-sm font-medium text-foreground-800 flex-1">{cat.name}</span>
                      <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-foreground-700 transition-colors"></i>
                    </a>
                  ))}
                </div>

                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  View All Categories
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col justify-between">
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">Updated Daily</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                  The AcBuy Spreadsheet is refreshed every single day with new products, verified seller links, and updated pricing information so you always have the most current data.
                </p>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20scene%20with%20laptop%20showing%20organized%20data%20spreadsheet%2C%20warm%20cream%20and%20beige%20tones%2C%20clean%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20neat%20desk%20with%20notebook%20and%20plant%2C%20professional%20atmosphere&width=700&height=500&seq=stats-updated-v3&orientation=landscape"
                  alt="Updated daily spreadsheet"
                  className="w-full h-48 object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}